import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_PURCHASE_PLANNING_SUPPLIERS_KEY } from '@/keys';
import type { LotSizingWeekRange } from '@/types/core/lot-sizing/lot-sizing-week-range';
import type { Supplier } from '@/types/core/purchase-planning/supplier';

const getPurchasePlanningSuppliers = async ({
  year,
  week,
  endYear,
  endWeek,
}: LotSizingWeekRange): Promise<Supplier[]> => {
  const response = await api.get<Supplier[]>('/purchase-plannings/suppliers', {
    params: {
      year,
      week,
      endYear,
      endWeek,
    },
  });

  return response.data;
};

export const useGetPurchasePlanningSuppliers = (
  weekRange: LotSizingWeekRange,
): UseSuspenseQueryResult<Supplier[], Error> =>
  useSuspenseQuery({
    queryKey: [...GET_PURCHASE_PLANNING_SUPPLIERS_KEY, weekRange],
    queryFn: () => getPurchasePlanningSuppliers(weekRange),
  });
